module.exports = __webpack_public_path__ + "img/GymBenches.1133acfe.png";